import { render, staticRenderFns } from "./Catetype.vue?vue&type=template&id=6d9945ea&scoped=true&"
import script from "./Catetype.vue?vue&type=script&lang=js&"
export * from "./Catetype.vue?vue&type=script&lang=js&"
import style0 from "./Catetype.vue?vue&type=style&index=0&id=6d9945ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9945ea",
  null
  
)

export default component.exports